module.exports = {
	permissions: require('./permissions.js'),
	util: require('./util.js')
};



//////////////////
// WEBPACK FOOTER
// ./~/functional-permissions-lib/index.js
// module id = TmQ0
// module chunks = 23